<template>
    <div class="flex flex-col gap-1 w-full">
        <AutoComplete v-model="selectedCliente" :suggestions="clienti" @complete="searchClienti" field="code"
            forceSelection optionLabel="code" @item-select="onClienteSelect" input-id="code"
            :placeholder="t('calendar.searchCustomerCodePlaceholder')" class="w-full" input-class="w-full">
            <template #option="slotProps">
                <div class="p-0">
                    <p class="font-semibold mb-1">{{ slotProps.option.name }}</p>
                    <p class="text-sm">{{ slotProps.option.code }}</p>
                </div>
            </template>
        </AutoComplete>
        <Message size="small" severity="secondary" variant="simple">{{ t('calendar.searchCustomerCodeHelp') }}</Message>
    </div>
</template>

<script setup lang="ts">
import { findCustomer } from '@/lib/api/customer'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
    modelValue: {
        type: Object,
        default: null
    }
})

const clienti = ref([])
const selectedCliente = ref(props.modelValue)

// Watch for external changes to modelValue
watch(() => props.modelValue, (newVal) => {
    selectedCliente.value = newVal
}, { immediate: true })

const searchClienti = async (event) => {
    const query = event.query?.trim()

    // Always reset to empty array first
    clienti.value = []

    if (!query) return

    try {
        const data = await findCustomer(query)

        if (!data) throw new Error(t('error.noDataFromServer'))

        clienti.value = data.items || []
    } catch (error) {
        console.error('Errore nel recupero clienti:', error)
        clienti.value = []
    }
}

const emit = defineEmits(['cliente-selezionato', 'update:modelValue'])

const onClienteSelect = (e) => {
    emit('cliente-selezionato', e.value)
    emit('update:modelValue', e.value)
}
</script>
